import { render, staticRenderFns } from "./CalendarBox.vue?vue&type=template&id=a654c214&scoped=true&"
import script from "./CalendarBox.vue?vue&type=script&lang=js&"
export * from "./CalendarBox.vue?vue&type=script&lang=js&"
import style0 from "./CalendarBox.vue?vue&type=style&index=0&id=a654c214&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a654c214",
  null
  
)

export default component.exports